import { Outlet, useLocation } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { Toaster } from "@/components/ui/sonner";
import FeedbackButton from "@/components/FeedbackButton";

const MainLayout = () => {
  const location = useLocation();

  // Only show footer on the public landing page
  const showFooter = location.pathname === '/';

  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />
      <main className="flex-1 pt-20">
        <Outlet />
      </main>
      <Toaster />
      {showFooter && <Footer />}
      <FeedbackButton />
    </div>
  );
};

export default MainLayout;
